import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';

import { MsisdnFormat } from './utils/pipes/msisdnFormat';
import { InlinePricesComponent } from './prices/inline-prices.component';
import { DecoratePricePipe, PriceFormatPipe } from './utils/pipes/price-format.pipe';
import { CurrencySymbolComponent } from './prices/currency-symbol.component';
import { UppercaseDirective } from './utils/directives/uppercase.directive';
import { FormControlNativeElDirective } from './customer-form/form-helpers/form-control-native-el.directive';
import { FormCheckboxValueDirective } from './customer-form/form-helpers/form-checkbox-value.directive';
import { TextMaskModule } from './customer-form/field-mask/field-mask.module';
import { PriceComponent } from './prices/price.component';
import StepPricesComponent from './prices/step-prices.component';
import { FormFieldErrorComponent } from './customer-form/form-helpers/form-field-error.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from "./utils/tooltip/tooltip.component";

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    TextMaskModule,
    NgSelectModule,
    TranslateModule.forRoot()
  ],
  declarations: [
    MsisdnFormat,
    PriceFormatPipe,
    DecoratePricePipe,
    PriceComponent,
    StepPricesComponent,
    InlinePricesComponent,
    CurrencySymbolComponent,
    UppercaseDirective,
    FormControlNativeElDirective,
    FormCheckboxValueDirective,
    FormFieldErrorComponent,
    TooltipComponent
  ],
  exports: [
    CommonModule,
    LayoutModule,
    TextMaskModule,
    NgSelectModule,
    MsisdnFormat,
    PriceFormatPipe,
    PriceComponent,
    StepPricesComponent,
    InlinePricesComponent,
    CurrencySymbolComponent,
    UppercaseDirective,
    FormControlNativeElDirective,
    FormCheckboxValueDirective,
    FormFieldErrorComponent,
    DecoratePricePipe,
    TranslateModule,
    TooltipComponent
  ],
  providers: []
})

export class SharedModule { }
